
import axios from 'axios'
import Router from 'vue-router'
import { Message,Notification  } from 'element-ui'
// create an axios instance
import router from '../router/index'
import Loading from '../components/Loading/index'
const instance = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 500000 // request timeout
})
let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
  /*loading = Loading.service({
    lock: true,
    text: '加载中。。。',
    background: 'rgba(0, 0, 0, 0.7)'
  })*/
   Loading.showLoading()

}
function endLoading() {    //使用Element loading-close 方法
  Loading.closeLoading();
}
const ok = 200

// ===== 后端 ResultCode 鉴权相关错误码 =====
// 1030=token无效或已过期, 1031=token已被禁止访问, 1036=访问未授权, 4001=未登录
const AUTH_ERROR_CODES = [1030, 1031, 1036, 4001]

instance.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }

    return config
  },
  error => {
    // Do something with request error
    Message.error('对不起，出错了')
    console.log(error) // for debug
    Promise.reject(error)
  }
)


instance.interceptors.response.use(
  response => {
    const res = response.data
    const errCode = res.code
    if (errCode !== undefined) {
      // debugger
      // 鉴权相关错误码：token无效/过期(1030)、token被禁止(1031)、访问未授权(1036)、未登录(4001)
      if (AUTH_ERROR_CODES.includes(errCode)) {
        Message({
          message: '你已被登出，请重新登录',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error('token expired'))
      }else if(errCode === 1000){  // BUSINESS_ERROR 业务异常
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(res)
      } else if (errCode !== ok) {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return res
    } else {
      return res
    }
  },
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  error => {
    const res = error.response;
    endLoading();
    if(res == undefined){
      localStorage.removeItem('token');
      localStorage.removeItem("role");
      localStorage.removeItem('folderId');
      router.push({path:"/login"});
    }
    if(res){
      if(res.status === 511 || res.status === 401){
        Notification({
          message: res.data.msg || res.data.message,
          type: 'error',
          duration: 5 * 1000
        })
        router.push({path:"/login"})
      }else if(res.status === 500 || res.status === 520 || res.status === 504){
        Message.error(res.data.msg || res.data.message);
      }else if(res.status === 901){
        Message.error('已超过系统最大请求，请稍等。。。')
      }
    }else{
      this.$message.error('登录过期，请重新登录');
      localStorage.removeItem('token');
      localStorage.removeItem("role");
      localStorage.removeItem('folderId');
      router.push({path:"/login"});
    }
    return Promise.reject(res)
  }
)

export const createAPI = (url, method, data, responseType) => {
  const config = {}

  if (method === 'get') {
    config.params = data
  } else {
    config.data = data
    if(responseType){
      config.responseType = responseType
    }
  }
  return instance({
    url,
    method,
    ...config
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js